import React, { useState } from "react";
import { Modal, Select, message } from "antd";
import { reassignConversation } from "../../../services/polly/classificationService";

const { Option } = Select;

export default function ReassignModal({ visible, conversationId, flatTopics, onCancel, onSuccess }) {
  const [selectedTopicId, setSelectedTopicId] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!selectedTopicId) {
      message.error("Please select a topic");
      return;
    }
    setLoading(true);
    try {
      await reassignConversation(conversationId, selectedTopicId);
      setSelectedTopicId(null);
      onSuccess();
    } catch (err) {
      console.warn("Failed to reassign conversation:", err);
      message.error("Failed to reassign conversation");
    }
    setLoading(false);
  };

  const handleCancel = () => {
    setSelectedTopicId(null);
    onCancel();
  };

  const activeTopics = (flatTopics || []).filter((t) => !t.disabled);

  return (
    <Modal
      title="Reassign Conversation"
      visible={visible}
      onOk={handleConfirm}
      onCancel={handleCancel}
      okText="Confirm"
      confirmLoading={loading}
      okButtonProps={{ disabled: !selectedTopicId || loading }}
    >
      <p style={{ color: "#555", marginBottom: 12 }}>Select a topic to reassign this conversation to:</p>
      <Select
        showSearch
        style={{ width: "100%" }}
        placeholder="Search topics..."
        value={selectedTopicId}
        onChange={setSelectedTopicId}
        filterOption={(input, option) =>
          option.children.toLowerCase().includes(input.toLowerCase())
        }
        disabled={loading}
      >
        {activeTopics.map((topic) => (
          <Option key={topic.id} value={topic.id}>
            {topic.name}
          </Option>
        ))}
      </Select>
    </Modal>
  );
}
